import { Result } from '../types/types'
import ProductCard from './ProductCard'

type Props = {
  products: Result[]
  customClasses?: string
}

const InstantSearchGrid = ({ products, customClasses }: Props): JSX.Element | null => {
  if (!products) {
    return <></>
  }

  return (
    <div
      className={`grid custom-grid-styling auto-rows-auto gap-[5px] md:gap-y-3 px-[7.5px] md:px-[10px] mx-auto relative overflow-visible ${
        customClasses ? customClasses : 'h-full'
      }`}
    >
      {products.map((product: Result) => {
        return (
          <div key={product.id} className="w-full">
            <ProductCard product={product} isShowWishlist={false} isShowSecondImage={false} />
          </div>
        )
      })}
    </div>
  )
}

export default InstantSearchGrid
